function getPixelValue(value) {
  const parsedValue = parseFloat(value);
  return Number.isFinite(parsedValue) ? parsedValue : 0;
}

function getChildrenStackHeight(element) {
  const computedStyle = window.getComputedStyle(element);
  const children = Array.from(element.children);

  if (!children.length) {
    return element.getBoundingClientRect().height;
  }

  const isColumnFlex =
    computedStyle.display.includes("flex") &&
    computedStyle.flexDirection.startsWith("column");
  const isSingleColumnGrid =
    computedStyle.display.includes("grid") &&
    computedStyle.gridTemplateColumns.split(" ").length <= 1;

  if (!isColumnFlex && !isSingleColumnGrid) {
    return element.getBoundingClientRect().height;
  }

  const gap = getPixelValue(computedStyle.rowGap || computedStyle.gap);
  const childrenHeight = children.reduce(
    (totalHeight, child) => totalHeight + child.getBoundingClientRect().height,
    0,
  );

  return childrenHeight + gap * Math.max(children.length - 1, 0);
}

function getWrapperVerticalPadding(wrapper) {
  const computedStyle = window.getComputedStyle(wrapper);

  return (
    getPixelValue(computedStyle.paddingTop) +
    getPixelValue(computedStyle.paddingBottom)
  );
}

export function syncIconCardStackOffset(
  section,
  wrappers,
  {
    uniformHeightProperty = null,
    offsetProperty,
    stackSelector = null,
  } = {},
) {
  if (!section || !offsetProperty) return;

  const wrapperEls = Array.from(wrappers).filter(Boolean);
  if (!wrapperEls.length) return;

  if (uniformHeightProperty) {
    section.style.removeProperty(uniformHeightProperty);
  }

  section.style.removeProperty(offsetProperty);

  let tallestHeight = 0;
  let tallestStackHeight = 0;
  let verticalPadding = 0;

  wrapperEls.forEach((wrapper) => {
    const stackElement = stackSelector
      ? wrapper.querySelector(stackSelector)
      : wrapper;

    tallestHeight = Math.max(
      tallestHeight,
      wrapper.getBoundingClientRect().height,
    );
    tallestStackHeight = Math.max(
      tallestStackHeight,
      getChildrenStackHeight(stackElement || wrapper),
    );
    verticalPadding = Math.max(
      verticalPadding,
      getWrapperVerticalPadding(wrapper),
    );
  });

  if (tallestHeight <= 0) return;

  const uniformHeight = Math.ceil(tallestHeight);
  const availableContentHeight = Math.max(uniformHeight - verticalPadding, 0);
  const iconOffset = Math.max(
    (availableContentHeight - tallestStackHeight) / 2,
    0,
  );

  if (uniformHeightProperty) {
    section.style.setProperty(uniformHeightProperty, `${uniformHeight}px`);
  }

  section.style.setProperty(offsetProperty, `${Math.ceil(iconOffset)}px`);
}
